import {
  GET_DASH_INFO,
  GET_DASH_INFO_SUCCESS,
  GET_DASH_INFO_FAILURE,
  GET_REG_PER_MONTH,
  GET_REG_PER_MONTH_SUCCESS,
  GET_REG_PER_MONTH_FAILURE,
} from "../constants";

const initialState = {
  dashboardInfo: {},
  studentRegPerMonth: [],
  schoolRegPerMonth: [],
  isDashInfoLoading: false,
  isRegLoading: false,
  error: null,
};

export default function AdminReducer(state = initialState, action) {
  switch (action.type) {
    case GET_DASH_INFO:
      state = {
        ...state,
        isDashInfoLoading: true,
        error: null,
      };
      break;
    case GET_REG_PER_MONTH:
      state = {
        ...state,
        isRegLoading: true,
        error: null,
      };
      break;

    case GET_DASH_INFO_SUCCESS:
      state = {
        ...state,
        dashboardInfo: action?.payload,
        isDashInfoLoading: false,
      };
      break;
    case GET_REG_PER_MONTH_SUCCESS:
      state = {
        ...state,
        studentRegPerMonth: action?.payload?.students,
        schoolRegPerMonth: action?.payload?.schools,
        isRegLoading: false,
      };
      break;
    case GET_DASH_INFO_FAILURE:
      state = {
        ...state,
        isDashInfoLoading: false,
        error: action.payload,
      };
      break;
    case GET_REG_PER_MONTH_FAILURE:
      state = {
        ...state,
        isRegLoading: false,
        studentRegPerMonth: [],
        schoolRegPerMonth: [],
        error: action.payload,
      };
      break;
    default:
      break;
  }
  return state;
}
